import React, {
  createContext,
  FC,
  PropsWithChildren,
  useContext,
  useEffect,
  useState,
} from "react";

import { DealerDataContext } from "~/app/Context/DealerContext";

export interface GetCurrentDealerContextPrpos {
  handleCurrentDealer: (prop: CurrentDealerProps) => void;
  currentDealer: CurrentDealerProps;
  clearDealer?: () => void;
}

interface CurrentDealerProps {
  DealerName: string;
  DealerNameEn: string;
  id: string;
}

const readDealerFromSession = (): CurrentDealerProps | null => {
  const id = sessionStorage.getItem("currentDealerId");
  if (!id) return null;
  return {
    id,
    DealerName: sessionStorage.getItem("currentDealerName") ?? "",
    DealerNameEn: sessionStorage.getItem("currentDealerNameEn") ?? "",
  };
};

export const GetCurrentDealerContext =
  createContext<GetCurrentDealerContextPrpos | null>(null);

const GetCurrentDealerProvider: FC<PropsWithChildren<React.ReactNode>> = ({
  children,
}) => {
  const [currentDealer, setCurrentDealer] = useState<CurrentDealerProps | null>(
    readDealerFromSession,
  );

  const dealerId = useContext(DealerDataContext)?.DealerId ?? null;

  // При автовыборе дилера (Layout подставляет первого дилера пользователя)
  // данные пишутся в sessionStorage и DealerContext, но не в этот контекст.
  // Догружаем их, чтобы контекст сразу содержал того же дилера,
  // что отображается в хедере.
  useEffect(() => {
    if (dealerId && currentDealer?.id !== dealerId) {
      const dealerFromSession = readDealerFromSession();
      if (dealerFromSession) setCurrentDealer(dealerFromSession);
    }
    // Зависим только от dealerId: после clearDealer() контекст не должен
    // восстанавливаться из sessionStorage сам по себе.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dealerId]);

  const handleCurrentDealer = (prop: CurrentDealerProps) => {
    setCurrentDealer(prop);
  };

  const clearDealer = () => {
    setCurrentDealer(null);
  };
  return (
    <GetCurrentDealerContext.Provider
      value={{ currentDealer, handleCurrentDealer, clearDealer }}
    >
      {children}
    </GetCurrentDealerContext.Provider>
  );
};

export default GetCurrentDealerProvider;
